import { openCreateOrganizationsModal } from "../../../redux/SettingModule/OrganizationsPage/OrganizationsPageAction";
import { useAppDispatch } from "../../../redux/useAppDispatch";

const CreateNewOrganizationsButton = (props: any) => {
  const dispatch = useAppDispatch();

  return (
    <>
      <button
        className="upload-btn"
        style={{ width: "120px" }}
        onClick={() => {
          dispatch(openCreateOrganizationsModal());
        }}>
        + Create New
      </button>
    </>
  );
};
export default CreateNewOrganizationsButton;
